export const domainDetails = {
    fancode: {
        logo: '/img/867f5c067d544a3f79567a893209f1c4 (1).svg',
        id: '630e193b397f3f66d5c7a6d5',
        name: 'Fancode'
    },
    cureayu: {
        logo: '/img/cureayu.png',
        id: '65c1cd8117be30519ff55096',
        name: 'Cureayu'
    },
    neemans: {
        logo: '/img/neemans.svg',
        id: '6634c8ad2fd1cb4630e9d1e8',
        name: 'Neemans',
        webUrl: 'https://neemans.com/',
        banner: {
            large: '/img/neemans_desktop.jpg',
            small: '/img/neemans_mobile.jpg'
        }
    },
    atovio: {
        logo: '/img/atovio.png',
        id: '67470509d56298539d20d8f7',
        name: 'Atovio',
        webUrl: 'https://atovio.in/',
        style: {
            filter: 'invert(1)'
        }
    },
    default: {
        logo: '/img/prozo.png'
    },
    comet: {
        logo: '/img/comet.png',
        id: '649c23adca521f1d45138702',
        name: 'Comet'
    },
    sg: {
        logo: '/img/sg.png',
        id: '62eba5701a6b3a0ad61ead99',
        name: 'SG'
    },
    tcpl: {
        logo: '/img/tcpl.png',
        id: '630e1e95397f3f66d5c7a79b',
        name: 'TCPL'
    },
    baidyanathayurved: {
        logo: '/img/baidyanathayurved.png',
        id: '669e35c34731fe7eb440a029',
        name: 'Baidyanath'
    },
    trusoul: {
        logo: '/img/trusoul.png',
        id: '66c47d5880b1e00948490629',
        name: 'Trusoul'
    },
    kayascience: {
        logo: '/img/kaya1.png',
        id: '66cec9ced191cf4d9129b9fd',
        name: 'Kaya'
    },
    oziss: {
        logo: '/img/oziss.png',
        id: '6698fa7a24f7124e4e33e05d',
        name: 'Oziss'
    },
    arihantpublications: {
        logo: '/img/arihantpublications.png',
        id: '653a064929a52f4b06fff2f2',
        name: 'Arihant Publications'
    },
    labelaarna: {
        logo: '/img/labelaarna.png',
        id: '673c92ec6496502aeed29c75',
        name: 'Label Aarna'
    },
    powerguard: {
        logo: '/img/powerguard.png',
        id: '6745a99242caba2f51a89ce2',
        name: 'Power Guard'
    },
    silvish: {
        logo: '/img/silvish.png',
        id: '674b0ee06ecff14abacec9cc',
        name: 'Power Guard'
    },
    godsmode: {
        logo: '/img/godsmode.png',
        id: '675ad76cf8793c7592636b90',
        name: 'Gods Mode'
    },
    superdog: {
        logo: '/img/superdog.png',
        id: '67482a7ad56298539d237e5b',
        name: 'Superdog'
    },
    sparify: {
        logo: '/img/sparify.png',
        id: '676e9ebaa20b635337613afc',
        name: 'Sparify'
    },
    ferrago: {
        logo: '/img/ferrago.png',
        id: '6773d72222a9005e7976e461',
        name: 'Ferrago'
    },
    youthnic: {
        logo: '/img/youthnic.png',
        id: '679b81061cf6977e529c6f7a',
        name: 'Youthnic'
    },


}